<template>
    <div class="container">
        <vue-speech class="text-transcription" lang="cs-CZ" @onTranscriptionEnd="onEnd"/>
        <vue-speak v-bind:message="speakenAnswer"/>
        <h1>Ask a question:</h1>
        <div class="form-group">
            <input class="form-control" v-model="question"/>
        </div>
        <div class="jumbotron"><p class="lead">{{ answer }}</p></div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VueSpeech from 'vue-speech'
    import VueSpeak from "@/components/VueSpeak";
    // var synth = window.speechSynthesis;
    // require('axios');
    const defaultAnswers = ["As I see it, yes.",
        "Ask again later.",
        "Better not tell you now.",
        "Cannot predict now.",
        "Concentrate and ask again.",
        "Don’t count on it.",
        "It is certain.",
        "It is decidedly so.",
        "Most likely.",
        "My reply is no.",
        "My sources say no.",
        "Outlook not so good.",
        "Outlook good.",
        "Reply hazy, try again.",
        "Signs point to yes.",
        "Very doubtful.",
        "Without a doubt.",
        "Yes.",
        "Yes – definitely.",
        "You may rely on it."];
    Vue.use(VueSpeech);
    export default {
        name: "EightBall",
        components: {VueSpeak},
        props: {},
        // components:{VueSpeech},
        data: function () {
            return {
                question: '',
                answer: '',
                speakenAnswer: '',
            };
        },
        watch: {
            question: function () {//newQuestion, oldQuestion
                this.answer = 'Waiting for you to stop typing...';
                this.debouncedGetAnswer();
            }
        },
        created: function () {
            // eslint-disable-next-line no-undef
            this.debouncedGetAnswer = _.debounce(this.getAnswer, 750);
            if(this.$route.query.q && this.$route.query.q.indexOf('?')!==-1){
                this.question = this.$route.query.q;
            }else if(this.$route.query.q){
                this.question = this.$route.query.q + '?';
            }

        },
        methods: {
            onEnd({lastSentence}) {//, transcription
                //console.log(transcription)
                this.question = lastSentence + "?"
                // `lastSentence` is the last sentence before the pause
                // `transcription` is the full array of sentences
            },
            getAnswer: function () {
                if (this.question.indexOf('?') === -1) {
                    this.answer = 'Questions usually contain a question mark. ;-)';
                    return
                }
                this.answer = 'Thinking...';
                let vm = this;
                // eslint-disable-next-line no-undef
                axios.get('https://cmd.akuma.cloud/answer', {timeout: 1000})
                    .then(function (response) {
                        // eslint-disable-next-line no-undef
                        vm.answer = _.capitalize(response.data.answer);
                        vm.speakenAnswer = vm.answer
                    })
                    // eslint-disable-next-line no-unused-vars
                    .catch(function (error) {
                        // vm.answer = 'Error! Could not reach the API. ' + error
                        vm.answer = defaultAnswers[Math.round(Math.random() * defaultAnswers.length)];
                        vm.speakenAnswer = vm.answer;
                    })
            }
        }
    }
</script>

<style scoped>
    span.text-transcription > p:not(:last-child) {
        visibility: hidden;
    }
</style>